<template>
    <div class="d-flex justify-center mt-2">
        <v-card class="rounded-xl" elevation="7" max-width="450" width="390" min-width="350">
            <v-card flat color="primary" height="120" class="d-flex align-center rounded-b-0 pa-2 position-relative">
                <v-row>
                    <v-col cols="8">
                        <v-img class="ml-3" width="300" max-width="235" src="@/assets/Logo-bt-06.png"></v-img>
                    </v-col>
                    <v-avatar size="110" style="position:absolute; left: 68%; top: 65px; border:3px solid #00a0df;">
                        <v-img v-if="user.fotocarnet" :src="`data:image/jpeg;base64,${user.fotocarnet}`" />
                        <v-img v-else src="@/assets/blank-user-profile.png" />
                    </v-avatar>
                </v-row>
            </v-card>
            <v-card-title class="text-body-1 font-weight-bold primary--text">
                {{ title }}
            </v-card-title>
            <v-card-text class="my-2">
                <div class="font-weight-bold black--text text-h5">LIC. {{
                    user.nombres
                    }} {{ user.apellido }}
                </div>
            </v-card-text>
            <v-card-text>
                <div class="font-weight-bold primary--text text-h5">MP: {{ user.nroafi }}
                </div>
                <div class="mt-1 font-weight-bold black--text text-h6">
                    {{ user.tipdoc }}: {{ user.nrodoc }}
                </div>
            </v-card-text>

            <v-card-text class="mt-2">
                <div class="d-flex font-weight-medium black--text text-body-1 justify-start">
                    {{ retiro }}
                    <b class="ml-1">{{ this.formatDate(user.estadodesde) }}</b>
                </div>
                <div class="d-flex font-weight-medium black--text text-body-1 justify-start mt-2">Resolución Nro.:
                    <b class="ml-1">
                        {{ user.resolucionjubiliado }}
                    </b>
                </div>
            </v-card-text>
            <v-card-text class="d-flex justify-center my-4 ">
                <v-img max-width="300" src="@/assets/credencial/firmas.png"></v-img>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import Alertas from '@/components/alerts/Alertas'
import { mapActions, mapGetters } from 'vuex';
export default {
    mounted() {

    },
    components: {
        Alertas,
    },
    data() {
        return {
            month: 0,
            date: '',
            message: 'La presente credencial tiene vencimiento el',
            retiro: 'Retiro profesional desde: '
        }
    },
    actions: {


    },
    computed: {
        ...mapGetters('auth', ['user']),
        title() {
            switch (this.user.sexo) {
                case 'F':
                    return 'AFILIADA JUBILADA';
                    break;
                case 'M':
                    return 'AFILIADO JUBILADO';
                    break;
                case 'X':
                    return 'AFILIADX JUBILADX';
                    break;
                default:
                    return 'AFILIADA/O JUBILADA/O';
                    break;
            }
        }
    },
    methods: {
        formatDate(date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },
    },

}
</script>


<style>
.rounded-card {
    /* You can adjust the value to control the roundness of the corners */
    box-shadow: 0 15px 18px rgba(0, 0, 0, 0.1);
    /* Optional: Add shadow for a more prominent card effect */
}
</style>